import ComparePage from './CompareLayout';
import { CAYDA, ADV } from './caydaFacts';

const VsMarkupIo = () => (
  <ComparePage
    slug="markup-io"
    competitor="Markup.io"
    description="Markup.io alternative: Cayda runs on your real site, bills per teammate instead of per MarkUp, and has native Jira, Asana and Linear. Free plan."
    hero="The Markup.io alternative billed by the person, not the MarkUp."
    intro="Markup.io loads your site through a proxy in an iframe and charges by how many MarkUps you create each month, from $79 for fifty. Cayda runs on your own domain, bills a base fee plus the teammates who accept an invite, and never counts how many pages you review."
    verdict={[
      { label: 'Starting price', cayda: '$9/mo', other: '$79/mo' },
      { label: 'Billed by', cayda: 'People', other: 'MarkUps per month' },
      { label: 'Free plan', cayda: 'Yes, no clock', other: '14 day trial, card required' },
      { label: 'Jira, Asana, Linear', cayda: 'Native, $14 tier', other: 'Zapier only' },
    ]}
    advantages={[
      { ...ADV.pricing, body: 'A base fee covers you; each accepted teammate is $5 to $6. Review a page once or a thousand times, it costs the same. Markup.io meters MarkUps created per month and charges $4 for each one over the allowance.' },
      { ...ADV.realSite, body: 'One script tag on your own domain. Notes anchor to the real element on the real page, so they do not go missing when content moves, and pages behind login work without a browser extension.' },
      { ...ADV.integrations, body: 'Slack on Pro. Jira, Asana and Linear natively on Team. A note on the page becomes an issue in your tracker without a Zapier recipe in between.' },
      { ...ADV.capture, body: 'Every note automatically records a screenshot, page URL, browser, OS and viewport. Screen recording on the Team plan. No extension needed to capture what the reviewer saw.' },
    ]}
    cost={{
      note: 'Cayda: annual billing, per month. Markup.io: markup.io/pricing, September 2026; the $79 Pro tier is monthly only.',
      scenarios: [
        { label: 'Solo freelancer', detail: 'unlimited sites and notes', cayda: 9, other: 79, caydaPlan: 'Pro, owner covered', otherPlan: 'Pro, 50 MarkUps/mo' },
        { label: 'Team of five, Slack', detail: 'status, priority, assignment, CSV', cayda: CAYDA.proPrice(4), other: 79, caydaPlan: 'Pro + 4 members', otherPlan: 'Pro, 50 MarkUps/mo' },
        { label: 'Team of ten, Jira', detail: 'plus Asana, Linear, screen recording, guests', cayda: CAYDA.teamPrice(9), other: 79, caydaPlan: 'Team + 9 members', otherPlan: 'Pro + Zapier for Jira' },
      ],
    }}
    diagram="proxy"
    features={{
      note: 'Cayda plan names in the Cayda column. Markup.io details from markup.io/pricing and its help centre, September 2026.',
      rows: [
        ['Free plan', CAYDA.free, 'None'],
        ['Entry paid plan', CAYDA.pro, '$79 · 50 MarkUps per month'],
        ['Overage', 'None', '$4 per extra MarkUp'],
        ['Jira, Asana, Linear', CAYDA.team, 'Zapier'],
        ['Slack', 'Pro', 'Pro'],
        ['Runs on your live domain', true, false],
        ['Pages behind login, web apps', true, 'Chrome extension'],
        ['Pins stay on the element when content moves', true, false],
        ['Visible to site visitors', 'Never', 'Never (separate link)'],
        ['Auto screenshot, browser, OS, viewport', true, 'Screenshot via extension'],
        ['Screen recording', 'Team', 'Loom integration'],
        ['Kanban + list dashboard, bulk actions', true, 'Statuses, folders'],
        ['Client / guest reviewers', 'Team, no member fee', 'Unlimited, no account'],
        ['CSV export', 'Pro', 'CSV, JSON'],
        ['WordPress plugin, Shopify app', true, 'Not listed'],
      ],
    }}
    approach={[
      'Markup.io, part of Ceros, is a creative review platform that also supports websites. A site is fetched through its proxy servers and rendered in an iframe; its help centre covers firewall whitelisting, sites that block iframes, and pins that go missing when the underlying content is updated or moved. Plans are usage based: fifty MarkUps a month for $79, up to six hundred on Business, with users unlimited and each MarkUp over the allowance billed at $4. Native integrations are Slack, Microsoft Teams, Zapier and Loom.',
      'Cayda is a website feedback tool for the team that owns the site: the review happens on your domain, notes anchor to real elements, the tracker integrations are native, and the bill tracks headcount rather than usage.',
    ]}
    bottomLine={[
      'For a team reviewing live sites and web apps, Cayda gives you pinned notes on the real page, automatic context, a triage board and native Jira, Asana and Linear, with a free plan and a bill that never spikes because you reviewed more pages this month. Start free on two sites.',
    ]}
  />
);

export default VsMarkupIo;
